// extracted by mini-css-extract-plugin
module.exports = {"Label":"css-modules_Label__apmGy","Switch":"css-modules_Switch__P47Qm","Thumb":"css-modules_Thumb__hG6Vt"};